// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"birthday_paragraph__o_t8Y","fromTo":"birthday_fromTo__p8dET","button":"birthday_button__fBbub"};